<template>
  <div class="speaker-detail base-basic">
    <!-- 顶部导航栏 -->
    <div class="top-nav">
      <van-icon name="arrow-left" class="back-icon" @click="goBack" />
      <div class="nav-title">专家详情</div>
    </div>

    <!-- 页面主体内容 -->
    <div class="content-container">
      <!-- <div class="speaker-card" v-if="speaker">
        <van-card 
          :title="speaker.name"
        >
          <template #thumb>
            <img src="https://placehold.co/100x100" alt="专家">
          </template>
<template #tags>
            <van-tag type="primary" plain style="margin-right: 8px;">领域: {{ speaker.field }}</van-tag>
            <van-tag type="success" plain>公司: {{ speaker.company }}</van-tag>
          </template>
</van-card>
</div> -->

      <div class="speaker-info" v-if="speaker">
        <div class="info-item">
          <span class="info-label">姓名:</span>
          <span class="info-value">{{ speaker.name }}</span>
        </div>
        <!-- <div class="info-item">
          <span class="info-label">标题:</span>
          <span class="info-value">{{ speaker.title }}</span>
        </div> -->
        <div class="info-item">
          <span class="info-label">省份:</span>
          <span class="info-value">{{ speaker.province }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">医院:</span>
          <span class="info-value">{{ speaker.standard_hospital_name }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">科室:</span>
          <span class="info-value">{{ speaker.standard_department }}</span>
        </div>

        <div class="info-item">
          <span class="info-label">院内职位:</span>
          <span class="info-value">{{ speaker.internal_position }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">学术任职情况:</span>
          <span class="info-value">{{ speaker.academic_position_detail }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">代言领域:</span>
          <span class="info-value">{{ speaker.endorsement_area }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">擅长话题:</span>
          <span class="info-value">{{ speaker.expertise_topics }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">剩余场次:</span>
          <span class="info-value">{{ speaker.remaining_meeting_count }}场</span>
        </div>
        <!-- <div class="info-item">
          <span class="info-label">教学经验:</span>
          <span class="info-value">{{ speaker.teaching_experience }}年</span>
        </div> -->
        <!-- <div class="info-item">
          <span class="info-label">合作等级:</span>
          <span class="info-value">{{ speaker.cooperation_level }}</span>
        </div> -->
        <!-- <div class="info-item">
          <span class="info-label">合作意愿:</span>
          <span class="info-value">{{ speaker.cooperation_willingness }}</span>
        </div> -->
        <!-- <div class="info-item">
          <span class="info-label">客户评价:</span>
          <span class="info-value">{{ speaker.customer_evaluation }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">邮箱:</span>
          <span class="info-value">{{ speaker.email }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">联系方式:</span>
          <span class="info-value">{{ speaker.contact }}</span>
        </div> -->
        <!-- <div class="info-item">
          <span class="info-label">单次处方量:</span>
          <span class="info-value">{{ speaker.single_prescription_amount }}</span>
        </div> -->
        <div class="info-item" v-if="speaker.speech_level">
          <span class="info-label">讲者级别:</span>
          <span class="info-value">{{ speaker.speech_level }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">创建时间:</span>
          <span class="info-value">{{ formatDateTime(speaker.created_time) }}</span>
        </div>
        <div class="info-item" v-if="speaker.updated_time">
          <span class="info-label">更新时间:</span>
          <span class="info-value">{{ formatDateTime(speaker.updated_time) }}</span>
        </div>
        <div class="info-item" v-if="speaker.liaison_officer_id">
          <span class="info-label">联络员:</span>
          <span class="info-value">{{ speaker.rpm }}</span>
        </div>
      </div>

      <div v-else class="loading">加载中...</div>

      <!-- <div class="action-buttons">
        <van-button 
          type="primary" 
          size="large"
          @click="goToSpeakerList"
        >
          返回专家列表
        </van-button>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Button, showSuccessToast, showFailToast, Loading } from 'vant';
import axios from '@/api/axios';

export default {
  name: 'SpeakerDetail',
  components: {
    VanButton: Button
  },
  data() {
    return {
      speaker: null,
      loading: false
    };
  },
  created() {
    this.loadSpeakerDetails();
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.back();
    },

    // 加载专家详情
    async loadSpeakerDetails() {
      const expertId = this.$route.params.id;
      this.loading = true;

      try {
        // 使用axios调用专家详情接口，添加page和limit参数
        const response = await axios.get(`/api/experts/${expertId}`, {
          params: {
            page: 1,
            limit: 10
          }
        });

        if (response.data.success) {
          this.speaker = response.data.data;
        } else {
          showFailToast('获取专家详情失败: ' + response.data.message);
        }
      } catch (error) {
        console.error('Error fetching speaker details:', error);
        showFailToast('请求专家详情时发生错误');
      } finally {
        this.loading = false;
      }
    },

    // 格式化日期时间
    formatDateTime(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '';

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 获取专家状态文本
    getExpertStatusText(status) {
      const statusMap = {
        0: '待审核',
        1: '审核通过',
        2: '审核失败',
        3: '已邀请',
        4: '已确认',
        5: '已拒绝'
      };
      return statusMap[status] || '未知状态';
    },

    // 返回专家列表
    goToSpeakerList() {
      this.$router.push('/my-speakers');
    },
    
    // 返回上一页
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.speaker-detail {
  background-color: #f7f8fa;
  min-height: 100vh;
  position: relative;
}

/* 顶部导航栏 */
.top-nav {
  display: flex;
  align-items: center;
  height: 48px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  padding: 0 15px;
  position: relative;
}

.back-icon {
  font-size: 20px;
  color: #333;
}

.nav-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.custom-header {
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 1000;
  display: flex;
  align-items: center;
  color: #1989fa;
  cursor: pointer;
}

.content-container {
  margin-top: 10px;
  padding: 0 16px;
}

.speaker-card {
  margin-bottom: 16px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.speaker-info {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.info-item {
  display: flex;
  padding: 8px 0;
  border-bottom: 1px solid #f2f3f5;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  width: 90px;
  color: #646566;
  font-weight: 500;
}

.info-value {
  flex: 1;
  color: #323233;
}

.action-buttons {
  padding: 16px;
}

.loading {
  text-align: center;
  padding: 20px;
  color: #969799;
}
</style>